import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import InspectPropPreviewBody from "./InspectPropPreviewBody";

export default function InspectPropPreview() {
  return (
    <PiPopupWindowPreview header={<PiPopupHeaderBar interactionType={InteractionType.InspectProp} title="Inspect Prop" />} body={<InspectPropPreviewBody />} />
  );
}
